import { ReactNode } from "react";

import Button from "@vfuk/core-button/dist/Button";
import Spacing from "@vfuk/core-spacing";

import { Warning } from "../../Warning";
import "../../assets/styles/common.scss";
import "../../assets/styles/common.scss";
import classes from "./WarningModalContent.module.scss";

export type WarningModalContentProps = {
  heading: string;
  body: string | ReactNode;
  confirmText: string;
  onConfirm: () => void;
  onClose?: () => void;
  showIcon?: boolean;
  isOpen?: boolean;
};

export const WarningModalContent = ({
  heading,
  body,
  confirmText,
  onConfirm,
  showIcon = false,
}: WarningModalContentProps): JSX.Element => (
  <div className={classes.WarningContents} role="dialog">
    {showIcon && (
      <div className={classes.warning}>
        <Warning />
      </div>
    )}
    <div className="modalMessage">{heading}</div>
    <Spacing spacingLevel={{ top: 4, left: 7, right: 7, bottom: 7 }}>
      <div className="modalSubmessage">{body}</div>
    </Spacing>
    <Spacing spacingLevel={{ left: 7, right: 7 }}>
      <Button width="auto" text={confirmText} onClick={onConfirm} />
    </Spacing>
  </div>
);
